import React from "react";
import {gql} from "@apollo/client";

import {ChallengeMode, UserInputAction} from "../../../schema";
import Bubble from "../Bubble";
import cn from "classnames";
import classes from "./UserInputBubble.module.css";
import Phrase, {PhraseVariant} from "../../Phrase";
import {useTranslation} from "react-i18next";
import ActionCompetenceBadge from "./ActionCompetenceBadge";

type props = React.ComponentProps<typeof Bubble> & {
  action: UserInputAction,
  onPlayClick?: React.MouseEventHandler,
  challengeMode: ChallengeMode
}

export default function UserInputBubble({action, className, onPlayClick, challengeMode, ...props}: props) {
  const {t} = useTranslation();

  return (
    <Bubble className={cn(classes.root, className)} {...props}>
      <Bubble.Content>
        {challengeMode === ChallengeMode.COMPETENCE_TEST ? (
          <>
            {action.freeSpeech
            ? (
              <>
                <Phrase
                  text={action.questionText}
                  variant={PhraseVariant.DEFAULT}
                  placeholder={(
                    <Bubble.Placeholder>{t("components.UserInputBubble.placeholder")}</Bubble.Placeholder>
                  )}
                />
                {action.competence && <ActionCompetenceBadge competenceName={action.competence.name} />}
                <i>{t("components.UserInputBubble.referenceText")}:</i>
                <Phrase
                  text={action.referenceText}
                  variant={PhraseVariant.DEFAULT}
                  placeholder={(
                    <Bubble.Placeholder>{t("components.UserInputBubble.referencePlaceholder")}</Bubble.Placeholder>
                  )}
                />
              </>)
            : (
              <>
                <Phrase
                  text={action.questionText}
                  variant={PhraseVariant.DEFAULT}
                  placeholder={(
                    <Bubble.Placeholder>{t("components.UserInputBubble.placeholder")}</Bubble.Placeholder>
                  )}
                />
                {action.competence && <ActionCompetenceBadge competenceName={action.competence.name} />}
                <i>{t("components.UserInputBubble.referenceText")}:</i>
                <Phrase
                  text={action.referenceText}
                  variant={PhraseVariant.DEFAULT}
                  placeholder={(
                    <Bubble.Placeholder>{t("components.UserInputBubble.referencePlaceholder")}</Bubble.Placeholder>
                  )}
                />
              </>
            )}
          </>
        ) : (
          <>
            {action.freeSpeech
            ? <i>{t("components.UserInputBubble.freeSpeechForModes")}:</i>
            : action.hintText && (
              <>
                {action.hintText}
                <i>{t("components.UserInputBubble.referenceTextForModes")}:</i>
              </>
            )}
            <Phrase
              text={action.referenceText}
              variant={PhraseVariant.DEFAULT}
              placeholder={(
                <Bubble.Placeholder>{t("components.UserInputBubble.placeholderForModes")}</Bubble.Placeholder>
              )}
            />
          </>
        )}
      </Bubble.Content>
    </Bubble>
  )
}


UserInputBubble.fragments = {
  root: gql`
    fragment UserInputBubble on UserInputAction {
      id
      hintText
      referenceText
      questionText
      freeSpeech
      competence {
        id
        __typename
        name
      }
    }
  `,
}
